import { Scene } from "@babylonjs/core/scene";
import { Animation } from "@babylonjs/core/Animations/animation";
import { AbstractMesh } from "@babylonjs/core/Meshes/abstractMesh";
import { performMarkJitter } from "common/model/animations/character/mark";
import { PLACE_JUMP_FRAMES, JITTER_FRAMES } from "./constants";

// 原地ジャンプ：その場で軽く跳ねる。withMark で頭上「！」マークも出す（衝突演出用）。
// speedRatio: アニメ速度倍率（デフォルト 1.0）
export const performCharPlaceJump = (
  scene: Scene,
  node: AbstractMesh,
  opts?: { withMark?: boolean },
  speedRatio = 1,
): Promise<void> =>
  new Promise<void>((resolve) => {
    if (!scene || scene.isDisposed) return resolve();

    if (opts?.withMark && scene.getMeshByName("mark")) {
      performMarkJitter(scene, node, JITTER_FRAMES);
    }

    const initialY = node.position.y;
    const anim = new Animation(
      "charPlaceJump",
      "position.y",
      PLACE_JUMP_FRAMES,
      Animation.ANIMATIONTYPE_FLOAT,
      Animation.ANIMATIONLOOPMODE_CONSTANT,
    );
    const keys = [];
    for (let i = 0; i <= PLACE_JUMP_FRAMES; i++) {
      const t = i / PLACE_JUMP_FRAMES;
      keys.push({
        frame: i,
        value: initialY + 0.6 * Math.sin(t * Math.PI),
      });
    }
    keys[keys.length - 1].value = initialY;
    anim.setKeys(keys);

    const a = scene.beginDirectAnimation(node, [anim], 0, PLACE_JUMP_FRAMES, false, speedRatio);
    a.onAnimationEnd = () => resolve();
  });
